type SeoHreflangProps = {
  canonical: string;
  englishUrl?: string;
};

export function seoHreflangTags({ canonical, englishUrl }: SeoHreflangProps) {
  return [
    <link key="he" rel="alternate" hrefLang="he" href={canonical} />,
    <link key="x-default" rel="alternate" hrefLang="x-default" href={canonical} />,
    ...(englishUrl ? [<link key="en" rel="alternate" hrefLang="en" href={englishUrl} />] : []),
  ];
}